import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { DownloadBrochurePopupComponent } from 'src/app/container/elements/download-brochure-popup/download-brochure-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { HttpIOService } from 'src/app/services/http-io.service';
import { DynamicSnacbarErrorComponent } from 'src/app/container/elements/dynamic-snacbar-error/dynamic-snacbar-error.component';
import { Helper } from 'src/app/helper/defult';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { PopupConfirmationComponent } from 'src/app/container/elements/popup-confirmation/popup-confirmation.component';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
})
export class AboutUsComponent implements OnInit {
  contactForm: UntypedFormGroup;
  emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9_.+-]{2,}$/;
  isSubmitting: boolean = false;

  // Employers logos list
  logos = [
    '../../../../assets/images/tbo-logo.webp',
    '../../../../assets/images/zedcrest-logo.webp',
    '../../../../assets/images/aim-logo.webp',
    '../../../../assets/images/pecan-logo.webp',
    '../../../../assets/images/routelink-logo.webp',
    '../../../../assets/images/qlc-logo.webp',
    '../../../../assets/images/magna-logo.webp',
    '../../../../assets/images/manna-logo.webp',
    '../../../../assets/images/fohat-logo.webp',
    '../../../../assets/images/arise-logo.webp',
    '../../../../assets/images/richway-logo.webp',
    '../../../../assets/images/platview-logo.webp',
    '../../../../assets/images/cochlear-logo.webp',
    '../../../../assets/images/gosolve-logo.webp',
  ]

  // Comments by the employers
  testimonials = [
    {
      logo: '../../../../assets/images/chidinma-icon.webp',
      heading: 'Nico Farms',
      para: 'Worknigeria provided excellent background check services for our company. Their process was thorough, efficient, and reliable, giving us complete confidence in the candidates we hired. The detailed reports were clear and timely, ensuring a smooth recruitment process.',
      saidBy: '',
    },
    {
      logo: '../../../../assets/images/emeka-icon.webp',
      heading: 'Bridgehead Engineering',
      para: 'Worknigeria exceeded our expectations in recruiting top-notch middle-level talent for our company. The candidates are a perfect fit, contributing immediately to our success. Highly recommend their recruitment services!',
      saidBy: '— HR Jonathan',
    },
    {
      logo: '../../../../assets/images/adenike-icon.webp',
      heading: 'Sundry Agro',
      para: 'Worknigeria\'\s document control course was concise, informative, and highly practical. It significantly improved our document management skills. Highly recommended!',
      saidBy: '— Nancy',
    },
  ]

  // Why choose work nigeria pointers
  items = [
    {
      heading: 'Leadership You Can Trust: ',
      para: ' Our team draws on years of expertise in recruitment and workforce development to confront Nigeria’s unemployment challenge head-on.'
    },
    {
      heading: 'Innovative Solutions: ',
      para: 'From free job postings to extensive training programs, we are shattering boundaries and creating possibilities for everybody.'
    },
    {
      heading: 'Commitment to Growth: ',
      para: 'We do not just match jobs; we build careers, supporting every stage of our job seekers’ journeys.'
    },
  ]

  // what we do
  whatWeDoList = [
    {
      id: 1,
      icon: "../../../../assets/images/we-do-c1.png",
      heading: "Recruitment Services",
      description: "We connect businesses with the right talent by matching skills, experience, and values to organizational needs.",
    },
    {
      id: 2,
      icon: "../../../../assets/images/we-do-c2.png",
      heading: "Background Check",
      description: "We carry out a thorough verification of employee certifications, training, educational claims, and more…",
    },
    {
      id: 3,
      icon: "../../../../assets/images/we-do-c3.png",
      heading: "ManPower Solutions",
      description: "Flexible staffing solutions providing skilled professionals for temporary, contract, or permanent positions.",
    },
    {
      id: 4,
      icon: "../../../../assets/images/we-do-c4.png",
      heading: "Job Board",
      description: "Access to our extensive network and proprietary job board connecting top talent with premier opportunities.",
    },
    {
      id: 5,
      icon: "../../../../assets/images/we-do-c5.png",
      heading: "Training & Development",
      description: "Professional development programs designed to enhance skills and accelerate career growth.",
    },
    {
      id: 6,
      icon: "../../../../assets/images/we-do-c6.png",
      heading: "HR Consulting",
      description: "Strategic HR advisory services helping organizations optimize their human capital management.",
    },
    {
      id: 7,
      icon: "../../../../assets/images/we-do-c7.png",
      heading: "Expatriate Management",
      description: "From immigration compliance to onboarding, we provide comprehensive solutions for managing expatriate employees.",
    }
  ]

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private io: HttpIOService,
    private snackBar: MatSnackBar,
    private helper: Helper,
  ) { }

  ngOnInit(): void {
    this.validationForm();
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  validationForm() {
    this.contactForm = this.fb.group({
      purpose: ['', Validators.required],
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.emailPattern),
        ]),
      ],
      message: ['', Validators.required],
    })
  }

  // Validation Controls //
  get f() {
    return this.contactForm.controls;
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  goToSignUp() {
    this.router.navigate(['/signup']);
  }

  downloadBrochure() {
    let successData = "about-us"
    const dialogRef = this.dialog.open(DownloadBrochurePopupComponent, {
      height: 'auto',
      width: '761px',
      autoFocus: false,
      data: {
        data: successData,
      },
    });
    dialogRef.afterClosed().subscribe();
  }

  /**
   * Handle contact form submission
   */
  onSubmit() {
    if (this.contactForm.status === 'INVALID') {
      this.helper.markFormGroupTouched(this.contactForm);
      return;
    }

    // Set submitting state
    this.isSubmitting = true;

    let payload = {
      path: '/helpdesk-email',
      message: this.contactForm.value.message,
      email: this.contactForm.value.email,
      subject: this.contactForm.value.purpose,
    }

    this.io._helpDeskEmail(payload).subscribe(
      (res: any) => {
        this.handleSuccess(res);
      },
      (error: any) => {
        this.handleError(error);
      }
    );
  }

  /**
   * Handle successful form submission
   */
  private handleSuccess(res: any): void {
    this.isSubmitting = false;

    if (res.serverResponse.code === 200) {
      let successData = "about us email"
      const dialogRef = this.dialog.open(PopupConfirmationComponent, {
        height: 'auto',
        width: 'auto',
        autoFocus: false,
        data: {
          data: successData,
        },
      });
      
      dialogRef.afterClosed().subscribe(() => {
        // Reset the form after dialog closes
        this.contactForm.reset();
        // Optional: Navigate to home or stay on page
        // this.router.navigate(['/home']);
      });
    } else {
      this.snackBar
        .openFromComponent(DynamicSnacbarErrorComponent, {
          data: res.serverResponse.message,
          verticalPosition: 'top',
          horizontalPosition: 'right',
          duration: 6000,
        })
        .afterOpened()
        .subscribe(this.helper.setOnTop);
    }
  }

  /**
   * Handle form submission error
   */
  private handleError(error: any): void {
    this.isSubmitting = false;
    
    this.snackBar
      .openFromComponent(DynamicSnacbarErrorComponent, {
        data: 'Failed to send message. Please try again later.',
        verticalPosition: 'top',
        horizontalPosition: 'right',
        duration: 6000,
      })
      .afterOpened()
      .subscribe(this.helper.setOnTop);
    
    console.error('Error details:', error);
  }

  /**
   * Check if a form field has error
   */
  hasError(fieldName: string, errorType?: string): boolean {
    const field = this.contactForm.get(fieldName);
    if (!field) return false;

    if (errorType) {
      return field.hasError(errorType) && (field.touched || field.dirty);
    }
    
    return field.invalid && (field.touched || field.dirty);
  }
}